module.exports = __webpack_public_path__ + "static/img/6690_phase_function_Paper_Points.831bab4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6690_phase_function_Paper_Points.png
// module id = v0Z/
// module chunks = 0